module.exports = __webpack_public_path__ + "images/6f6e0b0fcd5147438d4da7cc652157e7.png";